import { Navigate, useLocation } from "react-router-dom"
import { useAuth } from "../../providers/auth"

interface Props {
  children: React.ReactNode
}

const RequireAuth: React.FC<Props> = ({ children }) => {
  const { user } = useAuth()
  const location = useLocation()

  if (user) return <>{children}</>

  return (
    <Navigate
      to={{
        pathname: "/auth/sign-in",
      }}
      state={{ redirectTo: location.pathname + location.search }}
    />
  )
}

export default RequireAuth
